import styled from '@emotion/styled';
import { Button, Notice } from '@lbcamden/lib-react';

export const SupportNeedsNoticeRoot = styled(Notice)`
  margin-top: ${({ theme }) => theme.spacing(6)};

  ${Button} {
    margin-top: ${({ theme }) => theme.spacing(1)};
    font-weight: 500;
    text-decoration: underline;

    &:hover {
      color: ${({ theme }) => theme.colors.primaryHover};
    }
  }
`;

export const PersonList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(6)};
  padding: ${({ theme }) => theme.spacing([2, 0])};
  overflow: auto;
`;

export const PersonSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
`;
export const PersonSubSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  padding-left: ${({ theme }) => theme.spacing(3)};

  ul {
    margin: 0;
  }
`;
